import { render, staticRenderFns } from "./UserFormFrame.vue?vue&type=template&id=915f63ec&"
import script from "./UserFormFrame.vue?vue&type=script&lang=js&"
export * from "./UserFormFrame.vue?vue&type=script&lang=js&"
import style0 from "./UserFormFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports